import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

interface AdminGateProps {
  children: React.ReactNode;
}

export function AdminGate({ children }: AdminGateProps) {
  const user = useAppSelector((state) => state.auth.user);

  if (user?.role !== 'ADMIN') {
    return <Navigate to="/chats" replace />;
  }

  return <>{children}</>;
}
